import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Result, Button } from 'antd'

/**
 * Catches render-time errors so a single bad record cannot blank the whole console.
 * Without a boundary, an exception thrown from a column renderer or a list filter
 * unmounts the entire React tree and leaves the user staring at a white screen.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error('Unhandled render error', error, errorInfo) //eslint-disable-line no-console
  }

  handleReload = () => {
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return (
        <Result
          status="warning"
          title="หน้านี้ทำงานผิดพลาด"
          subTitle="ระบบหยุดแสดงผลหน้านี้ไว้ กรุณาโหลดหน้าใหม่อีกครั้ง หากยังพบปัญหาเดิม กรุณาแจ้งทีมพัฒนา"
          extra={
            <Button type="primary" onClick={this.handleReload}>
              โหลดหน้านี้ใหม่
            </Button>
          }
        />
      )
    }
    return this.props.children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
}

ErrorBoundary.defaultProps = {
  children: null,
}
